import { Button } from "../ui/button";
import { Activity } from "lucide-react";
import bg from "../../assets/bg.svg";


const Nav = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/60 bg-background/80 backdrop-blur-xl">
      <div className="container-tight flex h-16 items-center justify-between">
        <a href="/" className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-dark">
            <Activity className="h-4 w-4 text-signal" strokeWidth={2.5} />
          </div>
          <div className="flex items-center gap-2">
            <span className="text-base font-semibold tracking-tight text-foreground">Signal AI</span>
            <span className="inline-flex items-center gap-0">
              <span className="text-xs font-medium text-muted-foreground">by</span>
              <img src={bg} alt="Gowitek" className="h-6 w-auto object-contain" />
            </span>
          </div>
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          <a href="#what" className="text-sm text-muted-foreground transition-colors hover:text-foreground">What it does</a>
          <a href="#use-case" className="text-sm text-muted-foreground transition-colors hover:text-foreground">Use case</a>
          <a href="#how" className="text-sm text-muted-foreground transition-colors hover:text-foreground">How it works</a>
          <a href="#assessment" className="text-sm text-muted-foreground transition-colors hover:text-foreground">Assessment</a>
        </nav>
        <Button asChild size="lg" className="h-14 rounded-full bg-foreground px-8 text-lg font-bold text-background hover:bg-slate-mid">
          <a href="/assessment">Start at $0</a>
        </Button>
      </div>
    </header>
  );
};

export default Nav;
